var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.isLoggedIn)?_c('b-container',{staticClass:"mt-3"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('h1',[_vm._v("Welcome")])])],1)],1):_vm._e(),(!_vm.isLoggedIn)?_c('login-form'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }